const ServiceCommande = {
	
	convertMinutesToHoursMinutes: function(totalMinutes, short = false) {
		let h = Math.floor(totalMinutes / 60);
		let m = totalMinutes % 60;

		if (m < 10)
			m = '0' + m;

		if (short)
			return h + ':' + m;
		else
			return h + ' h ' + m + ' min';
	},

	// Time must be with format HH:MM
	convertHoursMinutesToMinutes: function(time) {
		// Split string
		let time_array = time.split(':');
		// Get hours
		let hours = time_array[0];
		// get minutes
		let minutes = time_array[1];

		return (Number(hours) * 60) + Number(minutes);
	}

}
export default ServiceCommande;